import * as CombosListActions from './list';
import * as CombosEditActions from './edit';

const Actions = {
  ...CombosListActions,
  ...CombosEditActions,
};

export default Actions;
